/* eslint-disable import/prefer-default-export */
import fetch from 'isomorphic-fetch';
import _ from 'lodash';
import * as ActionType from './types/SeatingChartActionTypes';
import { confirmation } from './NotificationActions';

function requestChart() {
  return {
    type: ActionType.REQUEST_CHART
  };
}

function receiveChart(json) {
  return {
    type: ActionType.RECEIVE_CHART,
    payload: {
      data: json
    }
  };
}

function requestCharts() {
  return {
    type: ActionType.REQUEST_CHARTS
  };
}

function receiveCharts(json) {
  return {
    type: ActionType.RECEIVE_CHARTS,
    payload: json
  };
}

function deleteChart() {
  return {
    type: ActionType.DELETE_CHART
  };
}

function createChart() {
  return {
    type: ActionType.CREATE_CHART
  };
}

function updateChart() {
  return {
    type: ActionType.UPDATE_CHART
  };
}

function redirectChart() {
  return {
    type: ActionType.REDIRECT_CHART
  };
}
/*
function changeView() {
  return {
    type: ActionType.CHANGE_VIEW
  };
}

function showDetails() {
  return {
    type: ActionType.SHOW_DETAILS
  };
}
*/
function requestTable() {
  return {
    type: ActionType.REQUEST_TABLE
  };
}

function receiveTable(json) {
  return {
    type: ActionType.RECEIVE_TABLE,
    payload: {
      guest: json
    }
  };
}

function requestTables() {
  return {
    type: ActionType.REQUEST_TABLES
  };
}

function receiveTables(json) {
  return {
    type: ActionType.RECEIVE_TABLES,
    payload: json
  };
}

function deleteTable() {
  return {
    type: ActionType.DELETE_TABLE
  };
}

function createTable() {
  return {
    type: ActionType.CREATE_TABLE
  };
}

function updateTable() {
  return {
    type: ActionType.UPDATE_TABLE
  };
}

export function onTableReorder(sourceIndex, hoverIndex) {
  return {
    type: ActionType.REORDER_TABLES,
    payload: {
      sourceIndex, hoverIndex
    }
  };
}

function createOrUpdateSeat() {
  return {
    type: ActionType.CREATE_UPDATE_SEAT
  };
}

export function loadEditTable(data) {
  return {
    type: ActionType.LOAD_EDIT_TABLE,
    payload: {
      data
    }
  };
}

export function selectGuest(guest, guestGroup, isCouple) {
  return {
    type: ActionType.SELECT_GUESTS,
    payload: {
      guest, guestGroup, isCouple
    }
  };
}

export function onSeatReorder(seat, sourceIndex, hoverIndex, tableUuid, fromTable, forceReorder) {
  return {
    type: ActionType.REORDER_SEATS,
    payload: {
      seat, sourceIndex, hoverIndex, tableUuid, fromTable, forceReorder
    }
  };
}

export function handleExpandGroup(guestGroup) {
  return {
    type: ActionType.EXPAND_GUEST_GROUP,
    payload: {
      guestGroup
    }
  };
}

export function changeSelectedChart(uuid) {
  return {
    type: ActionType.CHANGE_SELECTED_CHART,
    payload: {
      uuid
    }
  };
}
export function fetchChart(chartUuid) {
  return (dispatch) => {
    dispatch(requestChart());
    return fetch(`/web-api/v1/seatingchart/${chartUuid}`,
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function fetchChartList() {
  return (dispatch, getState) => {
    const accountId = getState().wedding.account.account_id;
    dispatch(requestCharts());
    return fetch(`/web-api/v1/seatingchart/account/${accountId}`,
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveCharts(json)));
  };
}

export function deleteSeatingChart(chartId) {
  return dispatch => (
    fetch(`/id/${chartId}/delete`,
      {
        method: 'POST',
        credentials: 'same-origin'
      })
      .then(() => dispatch(deleteChart(chartId)))
      .then(() => dispatch(confirmation({ message: 'Seating Chart Deleted' })))
  );
}

export function addNewChart(chartRequest) {
  return (dispatch, getState) => {
    const request = chartRequest;
    request.account_id = getState().wedding.account.account_id;
    request.wedding_account_id = getState().wedding.account.id;
    dispatch(createChart());
    return fetch('/web-api/v1/seatingchart',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(request)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function redirectToChart() {
  return (dispatch, getState) => {
    dispatch(redirectChart());
    const uuid = getState().seatingChart.seatingChart.uuid;
    window.location.href = `/wedding/manage/seating-chart/${uuid}/`;
  };
}

export function editChart(chartRequest) {
  return (dispatch) => {
    dispatch(updateChart());
    return fetch('/web-api/v1/',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(chartRequest)
      })
      .then(response => response.json());
  };
}

export function getTable(tableId) {
  return (dispatch) => {
    dispatch(requestTable());
    return fetch(`/id/${tableId}`,
      {
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTable(json)));
  };
}

export function fetchAllTable() {
  return (dispatch) => {
    dispatch(requestTables());
    return fetch('/list/all',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
      })
      .then(response => response.json())
      .then(json => dispatch(receiveTables(json)));
  };
}

export function removeTable(tableUuid) {
  return (dispatch, getState) => {
    const uuid = getState().seatingChart.seatingChart.uuid;
    dispatch(deleteTable());
    return fetch(`/web-api/v1/seatingchart/${uuid}/table/${tableUuid}`,
      {
        method: 'DELETE',
        credentials: 'same-origin'
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function addNewTables(tableRequest) {
  const newTablesRequest = tableRequest;
  console.log(tableRequest);
  return (dispatch, getState) => {
    newTablesRequest.account_id = getState().wedding.account.account_id;
    newTablesRequest.seating_chart_uuid = getState().seatingChart.seatingChart.uuid;
    const tables = getState().seatingChart.tables;
    newTablesRequest.num_tables = _.isEmpty(tables) ? 0 : _.size(tables);
    dispatch(createTable());
    return fetch('/web-api/v1/seatingchart/tables',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newTablesRequest)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function updateTables(tableRequests) {
  const newTablesRequest = {};
  newTablesRequest.tables = tableRequests;
  return (dispatch, getState) => {
    newTablesRequest.account_id = getState().wedding.account.account_id;
    newTablesRequest.seating_chart_uuid = getState().seatingChart.seatingChart.uuid;
    dispatch(updateTable());
    return fetch('/web-api/v1/seatingchart/tables',
      {
        method: 'PUT',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(newTablesRequest)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}

export function createOrUpdateSeats(seatRequests) {
  if (seatRequests == null) {
    return () => {};
  }
  const createOrUpdateSeatRequest = seatRequests;
  return (dispatch, getState) => {
    createOrUpdateSeatRequest.account_id = getState().wedding.account.account_id;
    createOrUpdateSeatRequest.seating_chart_uuid = getState().seatingChart.seatingChart.uuid;
    dispatch(createOrUpdateSeat());
    return fetch('/web-api/v1/seatingchart/table/seats',
      {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(createOrUpdateSeatRequest)
      })
      .then(response => response.json())
      .then(json => dispatch(receiveChart(json)));
  };
}




/** WEBPACK FOOTER **
 ** ./src/actions/SeatingChartActions.js
 **/